<script setup lang="ts">
import type { AlertProps } from "@nuxt/ui";
import type { ActivityParticipationValidationStatus, ParticipationResource } from "@carnet/api/backoffice";

const props = defineProps<{
  participation: ParticipationResource;
}>();

const { t } = useI18n();

// L'encadrant ne voit pas le statut de validation sur sa propre participation. Fail-open si le
// profil n'est pas résolu (membre courant null) : le backend reste le garde-fou réel.
const { isSupervised, isSupervisor } = useAppActivityPermissions(() => props.participation.activity);
const status = computed(() => props.participation.validationStatus);

type Statuses = Exclude<ActivityParticipationValidationStatus, "none">;

const colorForStatus: Record<Statuses, AlertProps["color"]> = {
  waiting_for_validation: "neutral",
  refused: "error",
  validated: "success",
};

const descriptionForStatus: Record<Statuses, string> = {
  waiting_for_validation: t("participation.validation.waiting_for_validation"),
  refused: t("participation.validation.refused"),
  validated: t("participation.validation.validated"),
};
</script>

<template>
  <UAlert
    v-if="isSupervised && !isSupervisor && status !== 'none' && status !== 'validated'"
    :description="descriptionForStatus[status]"
    :color="colorForStatus[status]"
    class="w-fit"
  />
</template>
